import * as React from "react";
import styles from "./Label.module.css";
import { cn } from "../../../utils/cn";

const Label = ({
  className,
  ...props
}: React.LabelHTMLAttributes<HTMLLabelElement>) => {
  return (
    <label
      className={cn(styles.label, className)}
      {...props}
      onMouseDown={(event) => {
        const target = event.target as HTMLElement;
        if (target.closest("button, input, select, textarea")) return;

        props.onMouseDown?.(event);
        if (!event.defaultPrevented && event.detail > 1) event.preventDefault();
      }}
    />
  );
};

export { Label };
